import { useEffect, useState } from "react";
import { fetchMedia, useStyles } from "./Content";

const Audio = ({ url: urlProp, id, name, autoplay, setAudioClip }) => {
  const [url, setUrl] = useState(urlProp);
  const [err, setErr] = useState(false);
  const classes = useStyles({});

  useEffect(() => {
    if (id) {
      fetchMedia(id)
        .then(data => setUrl(data.public_url))
        .catch(e => {
          console.error(e);
          setErr(true);
        });
    }
  }, [id]);

  useEffect(() => {
    if (url && autoplay) setAudioClip({ url, name });
  }, [url, name, autoplay, setAudioClip]);

  if (err)
    return <div className={classes.error}>Failed to load audio clip</div>;

  return (
    <div
      className={classes.audio}
      onClick={() => url && setAudioClip({ url, name })}
    >
      <p>
        <img
          src={`${window.location.origin}/tour/assets/play.svg`}
          alt="play"
        />
        {autoplay ? "Playing" : "Play"} {name}
      </p>
    </div>
  );
};

export default Audio;
